import { Text } from "@clipboard-health/ui-components";
import { type ReactNode } from "react";

export interface BookabilityCriteriaCardDescriptionTextProps {
  children: ReactNode;
}

export function BookabilityCriteriaCardDescriptionText(
  props: BookabilityCriteriaCardDescriptionTextProps
) {
  const { children } = props;

  return (
    <Text
      color={(theme) => theme.palette.text.secondary}
      variant="body2"
      data-testid="bookability-sheet-description"
    >
      {children}
    </Text>
  );
}
